import { createFileRoute } from "@tanstack/react-router";

import { PlatformAdminPanel } from "../../../../workspaces/settings/platform/PlatformAdminPanel";

export const Route = createFileRoute("/_console/settings/platform/")({
  component: PlatformAdminPanel,
});
